<template>
    <component :is="variant" class="kv-typography" :class="classes">
        <slot />
    </component>
</template>

<script>
export default {
    name: 'KvTypography',
    props: {
        variant: {
            type: String,
            default: 'span',
        },
        title: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String, // extra-small, small, regular, medium, large, extra-large, huge, giant, inherit
            default: 'regular',
        },
        weight: {
            type: String, // thin, extra-light, light, regular, medium, semibold, bold, extra-bold, black
            default: '400',
        },
        color: {
            type: String,
            default: 'default',
        },
        truncate: {
            type: Boolean,
            default: false,
        },
        hover: {
            type: Boolean,
            default: false,
        },
        lineBreak: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classes() {
            return [
                `kv-size-${this.size}`,
                `kv-weight-${this.weight}`,
                `kv-color-${this.color}`,
                this.title ? 'kv-title' : '',
                {
                    'kv-truncate': this.truncate,
                    'kv-hover': this.hover,
                    'kv-line-break': this.lineBreak,
                },
            ]
        },
    },
}
</script>

<style lang="less">
.kv-typography {
    color: #1f2a37;
    font-size: 14px;
    font-weight: 400;
}

&.kv-hover {
    transition: color 0.2s ease-in-out;
}

.kv-title {
    font-family: "Sora", sans-serif;
}

&.kv-hover:hover {
    color: #00542e;
}

/* WEIGHT */
.kv-weight-thin {
    font-weight: 100;
}

.kv-weight-extra-light {
    font-weight: 200;
}

.kv-weight-light {
    font-weight: 300;
}

.kv-weight-regular {
    font-weight: 400;
}

.kv-weight-medium {
    font-weight: 500;
}

.kv-weight-semibold {
    font-weight: 600;
}

.kv-weight-bold {
    font-weight: 700;
}

.kv-weight-extra-bold {
    font-weight: 800;
}

.kv-weight-black {
    font-weight: 900;
}

/* SIZE */
.kv-size-extra-small {
    font-size: 12px;
}

.kv-size-small {
    font-size: 13px;
}

.kv-size-regular {
    font-size: 14px;
}

.kv-size-medium {
    font-size: 16px;
}

.kv-size-large {
    font-size: 18px;
}

.kv-size-extra-large {
    font-size: 20px;
}

.kv-size-huge {
    font-size: 24px;
}

.kv-size-giant {
    font-size: 32px;
}

.kv-size-inherit {
    font-size: inherit;
}

&.kv-color-ai {
    background: linear-gradient(135deg,
            #F49E8A 0%,
            #E83E76 30%,
            #936CAD 65%,
            #2DBBDD 100%);

    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.kv-color-secondary {
    color: #4d5761;
}

.kv-color-success {
    color: #17B26A;
}

.kv-color-error {
    color: #F04438;
}

.kv-color-inherit {
    color: inherit;
}

/* HELPERS */
.kv-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.kv-line-break {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}
</style>
